module.exports = __webpack_public_path__ + "static/media/noticias_default.85b2ceef.jpg";